import { render, staticRenderFns } from "./StatementSuspensionOfContract.vue?vue&type=template&id=2a9c8c1e&"
import script from "./StatementSuspensionOfContract.vue?vue&type=script&lang=js&"
export * from "./StatementSuspensionOfContract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports